export default () => !/^passivedns/.test(window.location.host);
